var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9822 62.9999C79.6099 61.9853 80 60.8423 80 59.8158V24.184C80 23.1575 79.6105 22.0147 78.9825 21.0001L40 42L78.9822 62.9999Z",
    fill: "#00599C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.464 83.2299L76.5359 65.4141C77.4886 64.9009 78.3545 64.0147 78.9822 62.9999L40 42L1.01776 63.0001C1.64547 64.0147 2.51162 64.9011 3.46404 65.4141L36.5359 83.2299C38.441 84.2564 41.5589 84.2564 43.464 83.2299Z",
    fill: "#004482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9825 20.9999C78.3545 19.9851 77.4884 19.0989 76.5359 18.5856L43.4641 0.769868C41.559 -0.256623 38.441 -0.256623 36.5359 0.769868L3.46405 18.5856C1.55869 19.6119 0 22.1313 0 24.184V59.8158C0 60.8422 0.389804 61.9853 1.01778 62.9999L40 42L78.9825 20.9999Z",
    fill: "#659AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 66.8816C25.2959 66.8816 13.3333 55.7197 13.3333 41.9999C13.3333 28.2802 25.2959 17.1183 40 17.1183C49.4881 17.1183 58.337 21.8824 63.093 29.5513L51.5524 35.7825C49.172 31.9439 44.7451 29.5591 40 29.5591C32.6478 29.5591 26.6666 35.1399 26.6666 41.9999C26.6666 48.8597 32.6478 54.4408 40 54.4408C44.7456 54.4408 49.1725 52.056 51.5532 48.2167L63.0938 54.4476C58.3378 62.1173 49.4886 66.8816 40 66.8816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 40.6176H63.7035V37.853H60.7409V40.6176H57.7778V43.3821H60.7409V46.1469H63.7035V43.3821H66.6667V40.6176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7778 40.6176H74.8147V37.853H71.8521V40.6176H68.8889V43.3821H71.8521V46.1469H74.8147V43.3821H77.7778V40.6176Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 84,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c++.3335ab4506124eec0429548857676aff.svg";
export { ForwardRef as ReactComponent };